import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "references" }
const _hoisted_2 = { class: "references-grid" }
const _hoisted_3 = { class: "reference-image" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "overlay" }
const _hoisted_6 = { class: "reference-content" }
const _hoisted_7 = { class: "reference-icon" }
const _hoisted_8 = { class: "reference-category" }
const _hoisted_9 = { class: "reviews-grid" }
const _hoisted_10 = { class: "quote-icon" }
const _hoisted_11 = { class: "stars" }
const _hoisted_12 = { class: "review-text" }
const _hoisted_13 = { class: "review-author" }

import {ExternalLink, Home, Layers, Quote, ShieldCheck, Star} from "lucide-vue-next";
import "@/assets/styles/reference.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReferencesView',
  setup(__props) {

const references = [
  {
    icon: Home,
    title: "Steildach-Sanierung Wohnhaus",
    category: "Dachsanierung",
    image: "/images/references/steildach.png",
    text: "Neue Eindeckung mit langlebigem Systemaufbau, sauberer Entwässerung und präzisen Anschlüssen."
  },
  {
    icon: ShieldCheck,
    title: "Sturmschaden schnell gesichert",
    category: "Notdienst",
    image: "/images/references/sturmschaden.png",
    text: "Kurzfristige Sicherung, Schadensaufnahme und fachgerechte Reparatur nach starkem Unwetter."
  },
  {
    icon: Layers,
    title: "Flachdach-Abdichtung Gewerbe",
    category: "Flachdach",
    image: "/images/references/flachdach.png",
    text: "Robuste Abdichtung mit klarer Detailausbildung für dauerhaft trockene Nutzflächen."
  }
];

const reviews = [
  {
    name: "Familie Schneider",
    text: "Alles lief reibungslos. Sehr saubere Arbeit und ein Dach, das wieder richtig hochwertig aussieht."
  },
  {
    name: "Michael Bauer",
    text: "Pünktlich, zuverlässig und fachlich sehr stark umgesetzt."
  },
  {
    name: "Sandra Keller",
    text: "Nach dem Schaden wurde schnell reagiert und sauber repariert. Absolute Empfehlung!"
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-header" }, [
      _createElementVNode("span", { class: "section-badge" }, "Referenzen & Bewertungen"),
      _createElementVNode("h2", null, "Unsere Arbeit spricht für sich"),
      _createElementVNode("p", null, " Einblicke in echte Projekte und ehrliche Rückmeldungen unserer Kunden. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(references, (ref) => {
        return _createElementVNode("div", {
          class: "reference-card",
          key: ref.title
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: ref.image,
              alt: ref.title,
              loading: "lazy"
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ExternalLink))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(ref.icon)))
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(ref.category), 1),
            _createElementVNode("h3", null, _toDisplayString(ref.title), 1),
            _createElementVNode("p", null, _toDisplayString(ref.text), 1)
          ])
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (review) => {
        return _createElementVNode("div", {
          class: "review-card",
          key: review.name
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Quote))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
              return _createVNode(_unref(Star), { key: n })
            }), 64))
          ]),
          _createElementVNode("p", _hoisted_12, " \"" + _toDisplayString(review.text) + "\" ", 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(review.name), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})